export const routes = {
  LOGIN: "/login",
  REGISTRATION: "/registration",
  VERIFICATION: "/verification",
  RECOVERY: "/recovery",
  SETTINGS: "/settings",
  BOOKING: "/booking",
  SEARCH: "/booking/search",
  EXCHANGE: "/travel/:travelId/journey/:journeyId/exchange",
  EXCHANGE_SEARCH: "/travel/:travelId/journey/:journeyId/exchange/search",
  EXCHANGE_RESULTS: "/travel/:travelId/journey/:journeyId/exchange/results",
  EXCHANGE_RECAP: "/travel/:travelId/journey/:journeyId/exchange/recap",
  RESULTS: "/booking/results",
  PLACEMENTS: "/booking/placement",
  OPTIONS: "/booking/options",
  PASSPORT: "/booking/passport",
  RECAP: "/booking/recap",
  CART: "/booking/cart",
  PAYMENT: "/booking/payment",
  CONFIRMATION: "/booking/confirmation",
  ERROR: "/error",
  ADMIN: "/admin",
  HOME: "/",
  AGENCY_MANAGEMENT: "/admin/agencies",
  CAISSE_MANAGEMENT: "/admin/caisses",
  CAISSE_DETAILS: "/admin/caisses/:id",
  DAP_MANAGEMENT: "/admin/daps",
  DAP_DETAILS: "/admin/daps/:id",
  USER_MANAGEMENT: "/admin/users",
  USER_DETAILS: "/admin/users/:id",
  HELP: "/help",
  USER_BOOKINGS: "/bookings",
  CONTACT: "/admin/contact",
  PRIVACY_POLICY: "/legal/privacy",
  TERMS_AND_CONDITIONS: "/legal/terms",
  LEGAL_NOTICE: "/legal/notice",
};
